var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centering-track"},[_c('ul',{staticClass:"accepted-cards"},_vm._l((_vm.supportedCards),function(item,index){return _c('li',{key:index,class:item.cardName})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }